const DELIM = ";";

export function csvEscape(value: unknown): string {
  if (value === null || value === undefined) return "";
  const str = String(value);
  // Always quote to be safe (handles delimiters, quotes, and newlines)
  const escaped = str.replace(/"/g, '""');
  return `"${escaped}"`;
}

export function buildCsv(headers: string[], rows: Array<Array<unknown>>): string {
  const headerLine = headers.map(csvEscape).join(DELIM);
  const bodyLines = rows.map((r) => r.map(csvEscape).join(DELIM));
  // Prepend BOM to ensure proper display in Excel (UTF-8)
  return "\uFEFF" + [headerLine, ...bodyLines].join("\n");
}

export function downloadCsv(filename: string, csvContent: string) {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function formatCsvFilename(base: string, start?: Date, end?: Date) {
  if (start && end) {
    const f = (d: Date) => d.toISOString().split("T")[0];
    return `${base}_${f(start)}_${f(end)}.csv`;
  }
  return `${base}.csv`;
}
